import {
  getPurlDataUrl,
  getShareCodeByPlanUrl,
  getShareCodeUrl,
  getShareUrl,
  getShareWithIdUrl,
  getVerifyUrl,
} from "../config/Config";
import { getRequest, postRequest } from "./ServiceHelper";

export class ShareCodeService {
  static getExternalShareCode = (shareCodeId, ignoreRedirect) => {
    return getRequest(getShareCodeUrl(shareCodeId), null, ignoreRedirect);
  };

  static getShareable = (shareCodeId) => {
    return getRequest(getShareWithIdUrl(shareCodeId));
  };

  static getPlanShareCode = (planId) => {
    return getRequest(getShareCodeByPlanUrl(planId));
  };

  static createShareUrl = (shareData) => {
    return postRequest(getShareUrl(), shareData);
  };

  static verifyUser = (userData) => {
    return postRequest(getVerifyUrl(), userData);
  };

  static getPurlDataById = (purlId) => {
    return getRequest(getPurlDataUrl(purlId));
  };
}
